<div class="drawer">
    <input id="mobile-nav-drawer" type="checkbox" class="drawer-toggle" [checked]="mobileDrawerOpen" (change)="mobileDrawerOpen = !mobileDrawerOpen" />

    <!-- Main header content -->
    <div class="drawer-content">
        <nav class="navbar bg-base-100 px-1 py-1.5 sm:px-8 sm:py-4 shadow-md flex justify-between sticky top-0 z-[1000]">
            <!-- Hamburger button (mobile only) -->
            <button (click)="mobileDrawerOpen = true" class="btn btn-ghost btn-circle sm:hidden">
                <i class="fas fa-bars text-xl"></i>
            </button>

            <a [routerLink]="activeNavMode === 'admin' ? '/dashboard' : activeNavMode === 'dozent' ? '/home' : '/learning'" class="flex items-center gap-2 sm:gap-4">
                @if (brandingService.hasLogo()) {
                    <img [src]="brandingService.logo()"
                         [alt]="brandingService.platformName()"
                         class="h-10 w-auto object-contain hidden sm:block"
                         (error)="$event.target.style.display='none'" />
                    @if (brandingService.hasLogoSmall()) {
                        <img [src]="brandingService.logoSmall()"
                             [alt]="brandingService.platformName()"
                             class="h-8 w-auto object-contain sm:hidden"
                             (error)="$event.target.style.display='none'" />
                    } @else {
                        <img [src]="brandingService.logo()"
                             [alt]="brandingService.platformName()"
                             class="h-8 w-auto object-contain sm:hidden"
                             (error)="$event.target.style.display='none'" />
                    }
                    <div class="hidden bg-gradient-to-br from-primary via-secondary to-accent bg-clip-text text-transparent text-2xl font-bold">
                        {{ brandingService.platformShortName() }}
                    </div>
                } @else {
                    <div class="bg-gradient-to-br from-primary via-secondary to-accent bg-clip-text text-transparent text-2xl font-bold">
                        {{ brandingService.platformShortName() }}
                    </div>
                }
            </a>

            <!-- Navigation: switches based on active nav mode -->
            @if (activeNavMode === 'admin') {
                <!-- Admin Navigation -->
                <div class="hidden sm:flex gap-2 sm:gap-8">
                    <a routerLink="/teaching" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Lehre</a>
                    <a routerLink="/submissions" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Abgaben</a>
                    <a routerLink="/community" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">
                        <i class="fas fa-users mr-1"></i>Community
                    </a>
                </div>
            } @else if (activeNavMode === 'dozent') {
                <!-- Dozent Navigation -->
                <div class="hidden sm:flex gap-2 sm:gap-8 items-center">
                    <a routerLink="/home" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Übersicht</a>
                    <a routerLink="/teaching" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Lehre</a>
                    <a routerLink="/submissions" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Abgaben</a>
                    <a routerLink="/community" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">
                        <i class="fas fa-users mr-1"></i>Community
                    </a>
                </div>
            } @else {
                <!-- Teilnehmer Navigation -->
                <div class="hidden sm:flex gap-2 sm:gap-8 items-center">
                    <a routerLink="/home" routerLinkActive="text-primary" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Übersicht</a>
                    <a routerLink="/learning" routerLinkActive="text-primary" data-tour="nav-learning" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Lernen</a>
                    <a routerLink="/materials" routerLinkActive="text-primary" data-tour="nav-materials" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">Materialien</a>
                    <a routerLink="/community" routerLinkActive="text-primary" data-tour="nav-community" class="no-underline text-base-content/70 font-medium transition-colors duration-200 hover:text-primary text-sm sm:text-base">
                        <i class="fas fa-users mr-1"></i>Community
                    </a>
                </div>
            }

            <div class="flex items-center gap-2">
                <!-- View Mode Switcher -->
                @if (hasMultipleViewModes()) {
                    <div class="hidden sm:flex items-center bg-base-200 rounded-full p-0.5 gap-0.5">
                        @if (isAdmin()) {
                            <button (click)="setViewMode('admin')"
                                    class="btn btn-xs rounded-full px-3 gap-1.5 transition-all duration-200"
                                    [class]="viewModeService.isAdminMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50 hover:text-base-content'">
                                <i class="fas fa-cog text-xs"></i>
                                <span class="text-xs font-medium">Admin</span>
                            </button>
                        }
                        @if (isDozent()) {
                            <button (click)="setViewMode('dozent')"
                                    class="btn btn-xs rounded-full px-3 gap-1.5 transition-all duration-200"
                                    [class]="viewModeService.isDozentMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50 hover:text-base-content'">
                                <i class="fas fa-chalkboard-teacher text-xs"></i>
                                <span class="text-xs font-medium">Dozent</span>
                            </button>
                        }
                        @if (isTeilnehmer()) {
                            <button (click)="setViewMode('teilnehmer')"
                                    class="btn btn-xs rounded-full px-3 gap-1.5 transition-all duration-200"
                                    [class]="viewModeService.isTeilnehmerMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50 hover:text-base-content'">
                                <i class="fas fa-graduation-cap text-xs"></i>
                                <span class="text-xs font-medium">Teilnehmer</span>
                            </button>
                        }
                    </div>
                }

                <!-- Notification Bell -->
                <app-notification-bell></app-notification-bell>

                <div class="dropdown dropdown-end">
                    <div tabindex="0" role="button" class="flex items-center gap-2 sm:gap-4 hover:cursor-pointer">
                        <div class="text-right text-base-content hidden sm:block">
                            <div class="font-semibold">{{ getDisplayName(user) }}</div>
                            <div class="text-sm text-base-content/70">{{ translateRoles() }}</div>
                        </div>
                        <div class="btn btn-circle w-10 h-10 font-bold transition-transform duration-200 hover:scale-105 border-none p-0 overflow-hidden">
                            @if (user.profileImage) {
                                <img [src]="user.profileImage"
                                     [alt]="getDisplayName(user)"
                                     class="w-full h-full object-cover rounded-full"
                                     (error)="handleImageError($event)">
                                <div class="hidden w-full h-full bg-gradient-to-br from-primary via-secondary to-accent text-white flex items-center justify-center rounded-full">
                                    {{ getUserInitials(user) }}
                                </div>
                            } @else {
                                <div class="w-full h-full bg-gradient-to-br from-primary via-secondary to-accent text-white flex items-center justify-center rounded-full">
                                    {{ getUserInitials(user) }}
                                </div>
                            }
                        </div>
                    </div>
                    <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-56 p-2 shadow-lg border border-base-300">
                        @if (hasMultipleViewModes()) {
                            <li class="px-4 py-2">
                                <div class="text-xs text-base-content/40 mb-1.5 font-medium uppercase tracking-wide">Ansicht</div>
                                <div class="flex items-center bg-base-200 rounded-full p-0.5 gap-0.5">
                                    @if (isAdmin()) {
                                        <button (click)="setViewMode('admin')"
                                                class="btn btn-xs rounded-full px-3 gap-1.5 flex-1 transition-all duration-200"
                                                [class]="viewModeService.isAdminMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50'">
                                            <i class="fas fa-cog text-xs"></i>
                                            <span class="text-xs font-medium">Admin</span>
                                        </button>
                                    }
                                    @if (isDozent()) {
                                        <button (click)="setViewMode('dozent')"
                                                class="btn btn-xs rounded-full px-3 gap-1.5 flex-1 transition-all duration-200"
                                                [class]="viewModeService.isDozentMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50'">
                                            <i class="fas fa-chalkboard-teacher text-xs"></i>
                                            <span class="text-xs font-medium">Dozent</span>
                                        </button>
                                    }
                                    @if (isTeilnehmer()) {
                                        <button (click)="setViewMode('teilnehmer')"
                                                class="btn btn-xs rounded-full px-3 gap-1.5 flex-1 transition-all duration-200"
                                                [class]="viewModeService.isTeilnehmerMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50'">
                                            <i class="fas fa-graduation-cap text-xs"></i>
                                            <span class="text-xs font-medium">Teilnehmer</span>
                                        </button>
                                    }
                                </div>
                            </li>
                            <div class="divider my-0"></div>
                        }
                        <li>
                            <a routerLink="/settings" class="flex items-center gap-3 px-4 py-3 text-base-content hover:bg-base-200 rounded-lg transition-colors">
                                <i class="fas fa-cog text-base-content/60"></i>
                                <span>Einstellungen</span>
                            </a>
                        </li>
                        <li>
                            <a (click)="onLogout()" class="flex items-center gap-3 px-4 py-3 text-base-content hover:bg-error/10 hover:text-error rounded-lg transition-colors cursor-pointer">
                                <i class="fas fa-sign-out-alt text-base-content/60"></i>
                                <span>Abmelden</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>

    <!-- Drawer sidebar (mobile menu) -->
    <div class="drawer-side z-[1001]">
        <div class="drawer-overlay" (click)="mobileDrawerOpen = false"></div>
        <ul class="menu p-4 w-64 min-h-full bg-base-100">
            <li class="mb-4">
                <button (click)="closeDrawer()" class="btn btn-ghost btn-sm">
                    <i class="fas fa-times"></i>
                    Schließen
                </button>
            </li>

            @if (hasMultipleViewModes()) {
                <li class="mb-3">
                    <div class="text-xs text-base-content/40 mb-1.5 font-medium uppercase tracking-wide px-1">Ansicht</div>
                    <div class="flex items-center bg-base-200 rounded-full p-0.5 gap-0.5">
                        @if (isAdmin()) {
                            <button (click)="setViewMode('admin')"
                                    class="btn btn-xs rounded-full px-3 gap-1.5 flex-1 transition-all duration-200"
                                    [class]="viewModeService.isAdminMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50'">
                                <i class="fas fa-cog text-xs"></i>
                                <span class="text-xs font-medium">Admin</span>
                            </button>
                        }
                        @if (isDozent()) {
                            <button (click)="setViewMode('dozent')"
                                    class="btn btn-xs rounded-full px-3 gap-1.5 flex-1 transition-all duration-200"
                                    [class]="viewModeService.isDozentMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50'">
                                <i class="fas fa-chalkboard-teacher text-xs"></i>
                                <span class="text-xs font-medium">Dozent</span>
                            </button>
                        }
                        @if (isTeilnehmer()) {
                            <button (click)="setViewMode('teilnehmer')"
                                    class="btn btn-xs rounded-full px-3 gap-1.5 flex-1 transition-all duration-200"
                                    [class]="viewModeService.isTeilnehmerMode ? 'btn-primary shadow-sm' : 'btn-ghost text-base-content/50'">
                                <i class="fas fa-graduation-cap text-xs"></i>
                                <span class="text-xs font-medium">Teilnehmer</span>
                            </button>
                        }
                    </div>
                </li>
            }

            @if (activeNavMode === 'admin') {
                <li><a routerLink="/teaching" routerLinkActive="text-primary" (click)="closeDrawer()">Lehre</a></li>
                <li><a routerLink="/submissions" routerLinkActive="text-primary" (click)="closeDrawer()">Abgaben</a></li>
                <li><a routerLink="/community" routerLinkActive="text-primary" (click)="closeDrawer()">
                    <i class="fas fa-users mr-2"></i>Community
                </a></li>
            } @else if (activeNavMode === 'dozent') {
                <li><a routerLink="/home" routerLinkActive="text-primary" (click)="closeDrawer()">Übersicht</a></li>
                <li><a routerLink="/teaching" routerLinkActive="text-primary" (click)="closeDrawer()">Lehre</a></li>
                <li><a routerLink="/submissions" routerLinkActive="text-primary" (click)="closeDrawer()">Abgaben</a></li>
                <li><a routerLink="/community" routerLinkActive="text-primary" (click)="closeDrawer()">
                    <i class="fas fa-users mr-2"></i>Community
                </a></li>
            } @else {
                <li><a routerLink="/home" routerLinkActive="text-primary" (click)="closeDrawer()">Übersicht</a></li>
                <li><a routerLink="/learning" routerLinkActive="text-primary" (click)="closeDrawer()">Lernen</a></li>
                <li><a routerLink="/materials" routerLinkActive="text-primary" (click)="closeDrawer()">Materialien</a></li>
                <li><a routerLink="/community" routerLinkActive="text-primary" (click)="closeDrawer()">
                    <i class="fas fa-users mr-2"></i>Community
                </a></li>
            }
        </ul>
    </div>
</div>
